export default {
  list: {
    create: "Create company",
  },
  update: {
    delete: "Delete company",
  },
  create: {
    save: "Save company",
    cancel: "Cancel",
    reset: "Reset data",
  },
}
